function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.899 10c.558 0 1.01-.407 1.01-.91 0-.501-.452-.908-1.01-.908s-1.01.407-1.01.909.452.909 1.01.909zM3.899 0C2.117 0 .667 1.305.667 2.91c0 .4.361.726.808.726.446 0 .808-.325.808-.727 0-.802.725-1.454 1.616-1.454.891 0 1.616.652 1.616 1.454 0 .802-.725 1.455-1.616 1.455-.446 0-.808.325-.808.727v1.818c0 .402.362.727.808.727.446 0 .808-.325.808-.727V5.726C6.1 5.402 7.131 4.262 7.131 2.91 7.131 1.305 5.681 0 3.9 0z"
});

function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 10",
    fill: "currentColor"
  }, props), _ref);
}

export default SvgQuestionMark;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/question-mark.svg
// module id = 1301
// module chunks = 10